// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"274f03ea","197":"ba8b9e90","343":"a514fc27","453":"8a8089f3","824":"10a26883"}[chunkId] + ".chunk.js";
};